import loadScript from "./loadScript.mjs";
import { metricsClick } from "./genericAnalytics.mjs";
import { logger } from "./logger.mjs";
const getRecsLibAsync = (lg = logger) => new Promise((resolve) => {
  import("@rei/recommendations").then((recsLib) => {
    lg.log("recs library load success");
    resolve(recsLib);
  }).catch((err) => logger.error("recs library load failure", err));
});
function sendAlgonomyMvtAnalytics(pageName) {
  var _a, _b;
  const mvts = (_b = (_a = window == null ? void 0 : window.rr_mvtDetailed) == null ? void 0 : _a.mvtDetailed) == null ? void 0 : _b.filter((mvt) => mvt.testName.toLowerCase().includes(pageName)).map((mvt) => mvt.treatmentId).join("_");
  if (mvts == null ? void 0 : mvts.length) {
    metricsClick({ linkName: `Algonomy:${mvts}` }, {});
  }
}
const resolveRecsScript = (src, fnOverrides = { ls: loadScript, lg: logger }) => new Promise((resolve, reject) => {
  const { ls, lg } = fnOverrides;
  if (window.r3_common) lg.warn("RR - r3_common code already present");
  ls(src).then(({ timing }) => {
    if (window.r3_common) {
      lg.log("RR - script load", {
        start: timing.start,
        finish: timing.finish,
        duration: timing.finish - timing.start
      });
      resolve();
    } else {
      lg.error("RR - script load error", "r3_common not avaialable on window");
      reject();
    }
  }).catch((error) => {
    lg.error("RR - script load error", error);
    reject();
  });
});
const rrCallbackFn = (startTime, resolve, pageName, lg = logger) => () => {
  lg.log("RR - Init", {
    start: startTime,
    finish: window.performance.now(),
    duration: window.performance.now() - startTime
  });
  sendAlgonomyMvtAnalytics(pageName);
  resolve();
};
const initRecsOnPageLoad = async (config, fnOverrides = {
  rrcb: rrCallbackFn,
  lg: logger,
  ir: void 0,
  sipc: void 0
}) => new Promise(
  // eslint-disable-next-line no-async-promise-executor
  async (resolve, reject) => {
    const {
      rrcb,
      lg
    } = fnOverrides;
    try {
      const { setItemPageContext, default: initRecs } = await getRecsLibAsync(lg);
      const {
        sipc = setItemPageContext,
        ir = initRecs
      } = fnOverrides;
      const {
        style,
        name,
        category,
        placements
      } = config;
      const pageContextCB = () => sipc(style, name, category);
      const startTime = window.performance.now();
      ir({ pageContextCB, placements, rrCallback: rrcb == null ? void 0 : rrcb(startTime, resolve, "product-page") });
    } catch (error) {
      lg == null ? void 0 : lg.error(
        "RR - 3P error - initRecsOnPageLoad failed",
        error && (error instanceof Error || typeof error === "string") ? error : void 0
      );
      reject();
    }
  }
);
const getRecsPlacements = async (keyedPlacements, fnOverrides = { gpd: void 0, lg: logger }) => {
  const { getPlacementData } = await getRecsLibAsync(fnOverrides.lg);
  const { gpd = getPlacementData, lg } = fnOverrides;
  const placements = {};
  const placementNames = { ...keyedPlacements };
  Object.keys(placementNames).forEach((key) => {
    const placementData = gpd(placementNames[key]);
    if (placementData) {
      placements[key] = placementData;
    } else {
      lg == null ? void 0 : lg.warn("RR - 3P error - getRecsPlacements failure", `No placement data found for ${key}: ${placements[key]}`);
      placements[key] = {};
    }
  });
  return placements;
};
const sendRecsClick = async (data, logOverride, fnOverrides = { mc: metricsClick, brrch: void 0 }) => {
  const { buildRRClickHandler } = await getRecsLibAsync();
  const { mc, brrch = buildRRClickHandler } = fnOverrides;
  const composedMetricsClick = (clickData) => {
    mc(clickData, { logOverride });
  };
  const clickHandler = brrch(composedMetricsClick);
  clickHandler(data);
};
const initAddToCartRecs = (config, fnOverrides = {
  rrcb: rrCallbackFn,
  lg: logger,
  ir: void 0,
  satcpc: void 0
}) => new Promise(
  // eslint-disable-next-line no-async-promise-executor
  async (resolve, reject) => {
    const { setAddToCartPageContext, default: initRecs } = await getRecsLibAsync(fnOverrides.lg);
    const {
      satcpc = setAddToCartPageContext,
      ir = initRecs,
      rrcb = rrCallbackFn,
      lg = logger
    } = fnOverrides;
    const { sku, categoryId, placements } = config;
    const pageContextCB = () => {
      satcpc(sku, categoryId);
    };
    try {
      const startTime = window.performance.now();
      ir({
        reset: true,
        // clears page context and placements
        pageContextCB,
        placements,
        rrCallback: rrcb(startTime, resolve, "add-to-cart")
      });
    } catch (error) {
      lg.error(
        "RR - 3P error - initAddToCartRecs failed",
        error && (error instanceof Error || typeof error === "string") ? error : void 0
      );
      reject();
    }
  }
);
export {
  getRecsPlacements,
  initAddToCartRecs,
  initRecsOnPageLoad,
  resolveRecsScript,
  rrCallbackFn,
  sendRecsClick
};
//# sourceMappingURL=recommendations.mjs.map
